import { z } from 'zod'

import { SPACE } from '@nxt-insurance/ui-kit/constants'
import type { Space } from '@nxt-insurance/ui-kit/types'

import { spaceUnion } from '@/cms/helperTypes'
import type { PortableTextTypeComponentProps } from '@portabletext/react'

// The space can be used to _replace_ the spacing introduced by the surrounding stack. It does
// that by determining the space introduced by Stack. It then subtracts the Stack-space from its
// own space and adds that as margin-bottom to an empty div which will appear between the
// surrounding elements. Note that the margin-bottom value here might be negative (which would
// effectively reduce the space between the elements)
// Bacause the spacer is another element, sanity will also add a space of the default size below it.
// To compensate for this, an extra defaultSpacePx value is deducted at the end.

const spacer = z.object({
  _type: z.literal('spacer'),
  size: spaceUnion,
})

export const Spacer = (props: {
  node: PortableTextTypeComponentProps<unknown>
  defaultSpace?: Space
}) => {
  const value = spacer.parse(props.node.value)
  const marginBottom = SPACE[value.size] - SPACE[props.defaultSpace ?? 'medium']
  return <div style={{ marginBottom: marginBottom }}></div>
}
